import { useMemo } from 'react'
import { useI18n } from 'builder/hooks/useI18n'
import { LOCALIZATION_KEY, LOCALIZATION_KEY_VER_4 } from '../../constants'
import { useResumeDistributionABTest } from '../../hooks/useResumeDistributionABTest'
import { Container, Text, IconContainer, Icon } from './styles'

export const AvailableCountriesBanner = () => {
  const { i18n } = useI18n()
  const { resumeDistributionVersion } = useResumeDistributionABTest()

  const copy = useMemo(() => {
    return i18n.t(
      resumeDistributionVersion === 'v2'
        ? `${LOCALIZATION_KEY_VER_4}.available_countries_banner`
        : `${LOCALIZATION_KEY}.available_countries_banner`,
    )
  }, [i18n, resumeDistributionVersion])

  return (
    <Container>
      <IconContainer>
        <Icon />
      </IconContainer>
      <Text
        dangerouslySetInnerHTML={{
          __html: copy,
        }}
      />
    </Container>
  )
}
